import {TableName} from "../../EditableTable/options";
import {Type} from "../../Transaction/helper";

export function getTransactionType(tableName) {
    switch (tableName) {
        case TableName.batch_quotation:
            return Type.sale_quote;
        case TableName.batch_sale_order:
            return Type.sale_order;
        case TableName.batch_delivery_order:
            return Type.sale_delivery_order;
        case TableName.batch_invoice:
        case TableName.batch_invoice_cash:
            return Type.sale_invoice;
        case TableName.batch_invoice_credit_note:
            return Type.sale_credit_note;
        case TableName.batch_invoice_payment:
            return Type.sale_payment;
        case TableName.batch_sale_refund:
            return Type.sale_refund;
        case TableName.batch_purchase_order:
            return Type.purchase_order;
        case TableName.batch_bill:
        case TableName.batch_bill_cash:
        case TableName.batch_bill_expense_claim:
            return Type.purchase_bill;
        case TableName.batch_purchase_credit_note:
            return Type.purchase_credit_note;
        case TableName.batch_bill_payment:
            return Type.purchase_payment;
        case TableName.batch_bank_income:
            return Type.bank_income;
        case TableName.batch_bank_expense:
            return Type.bank_expense;
        case TableName.batch_journal_entry:
            return Type.journal_entry;
        default:
            throw new Error("Unknown table name", tableName);
    }
}
